import { render, staticRenderFns } from "./BacktestBollingerView.vue?vue&type=template&id=5c144b42&scoped=true"
import script from "./BacktestBollingerView.vue?vue&type=script&lang=js"
export * from "./BacktestBollingerView.vue?vue&type=script&lang=js"
import style0 from "./BacktestBollingerView.vue?vue&type=style&index=0&id=5c144b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c144b42",
  null
  
)

export default component.exports